<template>
    <f7-page>
        <f7-navbar>
            <f7-nav-left back-link="Atrás" sliding></f7-nav-left>
            <f7-nav-title>Favoritos</f7-nav-title>
        </f7-navbar>
        <f7-list media-list style="margin:0px;height:100%;overflow:auto;">
            <f7-list-item v-for="(anime, index) in animes"
                          :link="'/anime/'+ anime.id"
                          :key="index"
                          :text="anime.Sinopsis"
                          :title="anime.Titulo"
                          :subtitle="anime.Tipo">
                <img slot="media" :src="anime.Imagen" width="80"/>
            </f7-list-item>
        </f7-list>
    </f7-page>
</template>

<script>
    export default {
        data() {
            return {
                animes: [],
            }
        },
        methods: {
            cargar() {
                let self = this;
                self.$f7.preloader.show();
                this.$f7.request.json('https://www.jkanimeapp.com/ios/api.php?action=getFavoritos', function (data) {
                    self.animes = data.response;
                    self.$f7.preloader.hide();
                });
            }
        },
        mounted() {
            let self = this;
            this.$f7ready((f7) => {
                self.cargar();
            })
        },
    }
</script>
